import React, { useEffect } from "react";
import { AiOutlineShoppingCart } from "react-icons/ai";
import { MdOutlineDoneAll } from "react-icons/md";
import { FaListCheck } from "react-icons/fa6";
import { LuCalendarClock, LuCalendarCheck } from "react-icons/lu";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { get_dashboard_index_data } from "../../store/reducers/dashboardReducer";
import { get_appointment_by_client_id } from "../../store/reducers/appointmentReducerClient";
const Index = () => {
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.auth);
  const { totalOrder, pendingOrder, recentOrders, cancelledOrder } =
    useSelector((state) => state.dashboard);

  const {
    clientTotalAppointments,
    clientPendingAppt,
    clientAcceptedAppt,
    clientDoneAppt,
    clientRefusedAppt,
  } = useSelector((state) => state.appointmentsClient);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(get_dashboard_index_data(userInfo.id));
    dispatch(get_appointment_by_client_id(userInfo.id));
  }, [dispatch, userInfo.id]);
  const redirect = (ord) => {
    let items = 0;
    for (let i = 0; i < ord.length; i++) {
      items = ord.products[i].quantity + items;
    }
    navigate("/payment", {
      state: {
        price: ord.price,
        items,
        orderId: ord._id,
      },
    });
  };
  return (
    <div>
      <div className="grid grid-cols-3 md:grid-cols-1 gap-5">
        <div className="flex justify-between items-center p-5 bg-mainBg rounded-md gap-3 border-r-4 border-yellow-300">
          <div className="flex flex-col justify-start items-start ">
            <h2 className="text-2xl font-bold">{clientPendingAppt}</h2>
            <span className="text-sm">En Attente في انتظار القبول</span>
          </div>
          <div className="w-[46px] h-[47px] rounded-full bg-[#d5ba063b] flex justify-center items-center text-xl">
            <LuCalendarClock className="text-yellow-600 shadow-lg" />
          </div>
        </div>
        <div className="flex justify-between items-center p-5 bg-mainBg rounded-md gap-3 border-r-4 border-blue-500">
          <div className="flex flex-col justify-start items-start ">
            <h2 className="text-2xl font-bold">{clientAcceptedAppt}</h2>
            <span className="text-sm">Accepter المواعيد القادمة </span>
          </div>
          <div className="w-[46px] h-[47px] rounded-full bg-[#6356f544] flex justify-center items-center text-xl">
            <LuCalendarCheck className="text-[#3e5df6] shadow-lg" />
          </div>
        </div>
        <div className="flex justify-between items-center p-5 bg-mainBg rounded-md gap-3 border-r-4 border-green-500">
          <div className="flex flex-col justify-start items-start ">
            <h2 className="text-2xl font-bold">{clientDoneAppt}</h2>
            <span className="text-sm">Visites Réussis المواعيد الناجحه</span>
          </div>
          <div className="w-[46px] h-[47px] rounded-full bg-[#17e8001f] flex justify-center items-center text-xl">
            <MdOutlineDoneAll className="text-[#00e813] shadow-lg" />
          </div>
        </div>
        <div className="flex justify-between items-center p-5 bg-mainBg rounded-md gap-3 border-r-4 border-green-500">
          <div className="flex flex-col justify-start items-start ">
            <h2 className="text-2xl font-bold">{clientRefusedAppt}</h2>
            <span className="text-sm">Visites Annulées المواعيد الملغاة</span>
          </div>
          <div className="w-[46px] h-[47px] rounded-full bg-[#17e8001f] flex justify-center items-center text-xl">
            <MdOutlineDoneAll className="text-[#00e813] shadow-lg" />
          </div>
        </div>
        <div className="flex justify-between items-center p-5 bg-mainBg rounded-md gap-3 border-r-4 border-[#e800be]">
          <div className="flex flex-col justify-start items-start ">
            <h2 className="text-2xl font-bold">{clientTotalAppointments}</h2>
            <span className="text-sm">Visites Total مجموع المواعيد </span>
          </div>
          <div className="w-[46px] h-[47px] rounded-full bg-[#e800781f] flex justify-center items-center text-xl">
            <FaListCheck className="text-[#e800be] shadow-lg" />
          </div>
        </div>
        <div className="flex justify-between items-center p-5 bg-mainBg rounded-md gap-3 border-r-4 border-[#e800be]">
          <div className="flex flex-col justify-start items-start ">
            <h2 className="text-2xl font-bold">{totalOrder}</h2>
            <span className="text-sm">Commandes Total مجموع الطلبات </span>
          </div>
          <div className="w-[46px] h-[47px] rounded-full bg-[#e800781f] flex justify-center items-center text-xl">
            <AiOutlineShoppingCart className="text-[#e800be] shadow-lg" />
          </div>
        </div>
        <div className="flex justify-between items-center p-5 bg-mainBg rounded-md gap-3 border-r-4 border-[#002be8]">
          <div className="flex flex-col justify-start items-start ">
            <h2 className="text-2xl font-bold">{pendingOrder}</h2>
            <span className="text-sm">En Attente الطلبات في الانتظار</span>
          </div>
          <div className="w-[46px] h-[47px] rounded-full bg-[#e800781f] flex justify-center items-center text-xl">
            <AiOutlineShoppingCart className="text-[#002be8] shadow-lg" />
          </div>
        </div>
        <div className="flex justify-between items-center p-5 bg-mainBg rounded-md gap-3 border-r-4 border-[#e80046]">
          <div className="flex flex-col justify-start items-start ">
            <h2 className="text-2xl font-bold">{cancelledOrder}</h2>
            <span className="text-sm">Commandes Annulées الطلبات الملغاة </span>
          </div>
          <div className="w-[46px] h-[47px] rounded-full bg-[#e800781f] flex justify-center items-center text-xl">
            <AiOutlineShoppingCart className="text-[#e80046] shadow-lg" />
          </div>
        </div>
      </div>
      <div className="bg-mainBg p-4 mt-5 rounded-md">
        <h2 className="text-lg font-semibold text-slate-600">
          Commandes Récentes
        </h2>
        <div className="pt-4">
          <div className="relative overflow-x-auto">
            <table className="w-full text-sm text-left text-gray-500">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                <tr>
                  <th scope="col" className="px-6 py-3">
                    Id
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Prix
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Statut de paiement
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Statut de la commande
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {recentOrders.map((o, i) => (
                  <tr key={i} className="bg-white border-b">
                    <td className="px-6 py-4 font-medium whitespace-nowrap">
                      {o._id}
                    </td>
                    <td className="px-6 py-4 font-medium whitespace-nowrap">
                      {o.price} DA
                    </td>
                    <td className="px-6 py-4 font-medium whitespace-nowrap">
                      {o.payment_status}
                    </td>
                    <td className="px-6 py-4 font-medium whitespace-nowrap">
                      {o.delivery_status}
                    </td>
                    <td className="px-6 py-4">
                      <Link to={`/dashboard/order/details/${o._id}`}>
                        <span className="bg-green-100 text-green-800 text-sm font-normal mr-2 px-2.5 py-[1px] rounded">
                          Voir
                        </span>
                      </Link>
                      {o.payment_status !== "paid" && (
                        <span
                          onClick={() => redirect(o)}
                          className="bg-green-100 text-green-800 text-sm font-normal mr-2 px-2.5 py-[1px] rounded-2xl cursor-pointer"
                        >
                          Payer
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
